import {
  TICKET_LIST,
  TICKET_CREATE,
  TICKET_FILTER,
  TICKET_UPDATE,
  CONSIGNMENT_CREATE,
  CONSIGNMENT_CREATE_SUCCESS,
  CONFISCATION_CREATE,
  CONFISCATION_CREATE_SUCCESS,
  TICKET_CREATE_SUCCESS,
  TICKET_LIST_SUCCESS,
  TICKET_UPDATE_SUCCESS,
  INVOICE_CREATE,
  INVOICE_UPDATE,
  INVOICE_UPDATE_SUCCESS,
  INVOICE_CREATE_SUCCESS,
  BILLING_REQUEST_FAILED,
} from "store/billing/actionTypes";

const initialState = {
  tickets: [],
  ticketCreated: {},
  ticketUpdated: {},
  consignmentCreated: {},
  invoiceCreated: {},
  invoiceUpdated: {},
  confiscationCreated: [],
  loading: false,
  error: "",
};

const billing = (state = initialState, action) => {
  switch (action.type) {
    case TICKET_LIST:
      state = {
        ...state,
        loading: true,
      };
      break;
    case TICKET_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case TICKET_FILTER:
      state = {
        ...state,
        loading: true,
      };
      break;
    case TICKET_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONSIGNMENT_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case INVOICE_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case INVOICE_UPDATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case CONFISCATION_CREATE:
      state = {
        ...state,
        loading: true,
      };
      break;
    case TICKET_LIST_SUCCESS:
      state = {
        ...state,
        loading: false,
        tickets: action.payload,
        ticketCreated: {},
        ticketUpdated: {},
        consignmentCreated: {},
        invoiceCreated: {},
        invoiceUpdated: {},
        confiscationCreated: [],
        error: "",
      };
      break;
    case TICKET_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        ticketCreated: action.payload,
        error: "",
      };
      break;
    case TICKET_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        ticketUpdated: action.payload,
        error: "",
      };
      break;
    case CONSIGNMENT_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        consignmentCreated: action.payload,
        error: "",
      };
      break;
    case INVOICE_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        invoiceCreated: action.payload,
        error: "",
      };
      break;
    case INVOICE_UPDATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        invoiceUpdated: action.payload,
        error: "",
      };
      break;
    case CONFISCATION_CREATE_SUCCESS:
      state = {
        ...state,
        loading: false,
        confiscationCreated: action.payload,
        error: "",
      };
      break;
    case BILLING_REQUEST_FAILED:
      state = {
        ...state,
        loading: false,
        error: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default billing;
